import React, { useState, useEffect, createContext } from "react"
import { Container, Typography, Box } from "@material-ui/core"
import {
  createMuiTheme,
  makeStyles,
  responsiveFontSizes,
} from "@material-ui/core/styles"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "@material-ui/styles"
import { Helmet } from "react-helmet"

import { Theme, SetTheme } from "./Context"

import { theme as t } from "../config"
import Menu from "./Menu"
import Header from "./Header"
import hexToRgba from "../lib/hexToRgba"
import Seo from "../widgets/Seo"
import ReactPixel from "react-facebook-pixel"
const montserrat = {
  fontFamily: "Montserrat",
}

console.clear()
// console.log(
//   "%cSitio web hecho por kleber.digital " +
//     "%cWhatsapp: +591 70657034 " +
//     "%cWeb: www.kleber.digital",
//   "font-family: Arial; background:#2a2f36; color: #00ffec; font-size: 30px; border:2px solid #00ffec; padding: 8px; border-radius: 5px; margin: 10px 0",
//   "font-family: Arial; background:#075e54; color: #ece5dd; font-size: 15px; padding: 8px; border-radius: 5px; margin: 10px 10px 10px 0;",
//   "font-family: Arial; font-weight: bold; background: #00ffec; color: #2a2f36; font-size: 15px; padding: 8px; border-radius: 5px;"
// )
// const CartContext = createContext({ products: [], setCartContext: () => null })
const Layout = ({ children, setting }) => {
  const data = useStaticQuery(graphql`
    query Theme {
      sanitySetting {
        template
      }
    }
  `)
  const { template } = data.sanitySetting
  const [stateTemplate, setTemplate] = useState(template)
  const color = t(stateTemplate)
  const theme = responsiveFontSizes(
    createMuiTheme({
      overrides: {
        MuiButton: {
          label: {
            fontWeight: "bold",
          },
        },
        MuiDialog: {},
        MuiBackdrop: {
          root: {
            backgroundColor: hexToRgba("#000000", 0.8),
          },
        },
      },
      typography: {
        fontFamily: ["Montserrat", "Robot", "sans-serif"],
      },
      palette: {
        type: stateTemplate,
        primary: { main: color.turquesa, dark: color.gray },
        secondary: { main: color.red },
        background: {
          paper: color.grayLight,
          default: color.gray,
        },
      },
    })
  )
  useEffect(() => {
    ReactPixel.init(process.env.PIXEL_FACEBOOK_GLOBAL)
    ReactPixel.pageView()
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <Seo
        title={setting.title}
        description={setting.description}
        logo={setting.logo.asset.url}
        url={setting.url}
        image={setting.cover && setting.cover.asset && setting.cover.asset.url}
      />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
        <meta name="mobile-web-app-capable" content="yes"></meta>
      </Helmet>
      <Theme.Provider value={stateTemplate}>
        <SetTheme.Provider
          value={() =>
            stateTemplate === "dark"
              ? setTemplate("light")
              : setTemplate("dark")
          }
        >
          <Container>
            <Header></Header>
            {children}
          </Container>
          <Menu logo={setting.logo.asset.url} title={setting.title}></Menu>
        </SetTheme.Provider>
      </Theme.Provider>
      <style global="true" jsx="true">
        {`
          body {
            background: ${color.gray};
          }
        `}
      </style>
    </ThemeProvider>
  )
}

export default Layout
